import { TYPE as EQUIPMENT_TYPE } from 'src/constants/mx/equipment';

export const getType = type => type || type === 0 ? type : null;

export const isLandingsAvailable = type => type === EQUIPMENT_TYPE.AIRFRAME;
export const isCyclesAvailable = type => type === EQUIPMENT_TYPE.ENGINE;
